import request from '@/utils/request'

// 根据类型获取数据字典
export function getDictByType(data) {
    return request({
        url: `/survey/baseDictionary/getDictByType`,
        method: 'get',
        params: data
    })
}

// 根据上级编码获取省市区列表
export function getDistrictByParentCode(data) {
    return request({
        url: `/survey/systemDistrict/getDistrictByParentCode`,
        method: 'get',
        params: data
    })
}
// 官网Pc-专家团队List
export function getExpertList(data) {
    return request({
        url: `/survey/expertTerm/getExpertList`,
        method: 'post',
        data
    })
}
// 官网Pc-品牌新闻动态List
export function getPcNewsList(data) {
    return request({
        url: `/survey/newsInformation/getPcNewsList`,
        method: 'post',
        data
    })
}
// 官网Pc-官网轮播图List
export function getPicList(data) {
    return request({
        url: `/survey/homeRotatePic/getPicList`,
        method: 'post',
        data
    })
}
// 官网Pc-查看新闻动态,回显并记录阅读量
export function pcReadNewsInfo(data) {
    return request({
        url: `/survey/newsInformation/pcReadNewsInfo`,
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/public.js